import { Type } from './type';
import { Status } from './status';

export class LogSheetSummaryDTO {
    id: string;     
    type: Type;
    subject: string;
    status: Status;
    lastCreatedDate: Date;//Latestentry Created Date
  }